module.exports = __webpack_public_path__ + "static/1-001-863723b9edae168c41e7fc102891cc6a.png";